/* eslint-disable no-console */

import { register } from 'register-service-worker'

/*const notifyUserAboutUpdate = worker => {
  // TODO create here snackbar and wait for confimation of the user to update
  // https://levelup.gitconnected.com/vue-pwa-example-298a8ea953c9
  worker.postMessage({action: "skipWaiting"});
}*/

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready (registration) {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
    },
    cached (registration) {
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      //With GenerateSW ref https://stackoverflow.com/questions/54145735/vue-pwa-not-getting-new-content-after-refresh
      window.location.reload(true)
      //With IngestedManifest
      //registration.waiting.postMessage({action: "SKIP_WAITING"});
      //notifyUserAboutUpdate(registration.waiting);
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  });

  /*var refreshing: boolean;
  navigator.serviceWorker.addEventListener("controllerchange", function(){
    if (refreshing) return;
    window.location.reload();
    refreshing = true;
  })*/
}
